import React from 'react'

import Fees from './components/package/Fees';
import Div from './components/layouts/Div'

import { FEE_INFO_PARTNER_SETTINGS } from '../constants/Variables';

import AuthManager from '../utils/AuthManager';
import Backend from '../utils/Backend';
import Notify from '../utils/Notify';
import General from '../utils/General';

export default class PartnerFees extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      association: General.clone(AuthManager.currentUser.association),
      feeErrors: null,
      loading: false
    }

  }

  _handleUpdate() {
    let { association } = this.state;

    this.setState({ loading: true });

    Backend.updateAssociation(association).then((association) => {
      Notify.success("Fees Updated Successfully.");
      AuthManager.currentUser.association = association;
      let data = General.clone(association);
      this.setState({ association: data, loading: false, feeErrors: null });
    }).catch((error) => {
      let errorMessage = error.message;
      Notify.error(errorMessage)
      this.setState({ loading: false, feeErrors: error.raw?.rates?.schemes || null });
    })
  }

  render() {
    let {
      association,
      feeErrors,
      loading,
    } = this.state

    if (!association) return null

    return (
      <Div disabled={loading} showLoadingIndicator={true}>
        <div className="kt-portlet custom-form">
          <div className="kt-portlet__body">
            <Fees
              mode={"package"}
              infoText={FEE_INFO_PARTNER_SETTINGS}
              association={association}
              errors={feeErrors}
              rates={association.rates}
              onUpdate={(rates) => {
                association.rates = rates
                this.setState({ association })
              }}
            />
          </div>

          <div className="kt-portlet__foot">
            <div className="kt-form__actions pull-right">
              <button
                type="button"
                className="btn btn-primary ml-3"
                disabled={loading}
                onClick={() => this._handleUpdate()}
              >
                Update
              </button>
            </div>
          </div>
        </div>
      </Div>
    )
  }

}
